<template>
  <div class="sr-page">
    <div class="sr-card">
      <div class="sr-icon sr-icon--blocked">
        <i class="pi pi-ban"></i>
      </div>

      <h1 class="sr-title">تم تعليق هذا الجهاز</h1>
      <p class="sr-text">
        تم تعليق هذا الجهاز. برجاء التواصل مع الإدارة.
      </p>

      <div class="sr-actions">
        <button class="sr-btn sr-btn--grad" @click="backToLogin">
          <i class="pi pi-sign-in"></i> تسجيل الدخول
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceSuspended',
  methods: {
    backToLogin() {
      this.$store.dispatch('logout');
      this.$router.replace('/login');
    },
  },
};
</script>

<style scoped>
.sr-page { min-height: 70vh; display: flex; align-items: center; justify-content: center; padding: 2rem 1rem 5rem; }
.sr-card {
  background: #fff; border: 1px solid rgba(239,68,68,.15); border-radius: 22px;
  padding: 2.5rem 1.8rem; max-width: 460px; width: 100%; text-align: center;
  box-shadow: 0 12px 40px rgba(239,68,68,.1);
}
.sr-icon {
  width: 88px; height: 88px; border-radius: 50%; margin: 0 auto 1.4rem;
  display: flex; align-items: center; justify-content: center; font-size: 2.4rem;
}
.sr-icon--blocked { background: rgba(239,68,68,.1); color: #ef4444; }
.sr-title { font-size: 1.5rem; font-weight: 800; color: #111827; margin-bottom: .6rem; }
.sr-text { color: #6B7280; line-height: 1.9; font-size: .95rem; }
.sr-actions { display: flex; flex-direction: column; gap: .6rem; margin-top: 1.75rem; }
.sr-btn {
  border: none; border-radius: 12px; padding: .8rem 1rem; font-weight: 800; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center; gap: .5rem; font-size: .95rem;
}
.sr-btn--grad { background: linear-gradient(90deg, #5B5FEF, #7c4dff); color: #fff; }
</style>
